<template>
  <div>
    <ReportPieChart
      ref="statusChart"
      :height="height"
      :width="width"
      :report-data="reportData"
      :legend="legend"
      :show-percentages="true"
      title="Corruption Cases by Status"
    />
  </div>
</template>

<script>
import axios from "axios";
import ReportPieChart from "./ReportPieChart.vue";

export default {
  components: {
    ReportPieChart
  },
  props: {
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      decided: 0,
      on_trial: 0,
      suspended: 0,
      withdrawn: 0
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    },
    reportData() {
      return {
        Decided: this.decided,
        "On Trial": this.on_trial,
        Suspended: this.suspended,
        Withdrawn: this.withdrawn
      };
    },
    legend() {
      return {
        Decided: "#339966",
        "On Trial": "#b6142c",
        Suspended: "#e77e4e",
        Withdrawn: "#a2b86c"
      };
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.run();
      }
    }
  },
  mounted() {
    this.run();
  },
  methods: {
    run() {
      axios
        .get(`${window.host}/api/cases-status`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.decided = response.data.decided;
            this.on_trial = response.data.on_trial;
            this.suspended = response.data.suspended;
            this.withdrawn = response.data.withdrawn;
          }
        });
    }
  }
};
</script>
